import { Kbd as MKbd } from '@mantine/core';

/** Small keyboard hint, e.g. <K>⌥F</K>. */
export const K = ({ children }: { children: string }) => <MKbd size="xs" style={{ fontSize: 10, padding: '0 4px' }}>{children}</MKbd>;
